module.exports = __webpack_public_path__ + "assets/img/downreport.a43c7bef.svg";